import React from 'react';

const NoticeComponent = props => (
  <svg width={16} height={16} {...props}>
    <defs>
      <circle id="prefix__a" cx={8} cy={8} r={8} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b" fill="#fff">
        <use xlinkHref="#prefix__a" />
      </mask>
      <use fill="#667580" xlinkHref="#prefix__a" />
      <g mask="url(#prefix__b)" fill="#3D98FF">
        <path d="M0 0h16v16H0z" />
      </g>
      <path
        d="M7.223 6.089l1.505-.422v6.067H7.223V6.09zm-.065-1.881c0-.103.02-.2.062-.29.042-.091.1-.17.174-.238a.844.844 0 0 1 .575-.218.849.849 0 0 1 .574.218.756.756 0 0 1 .176.237c.043.09.065.188.065.291 0 .103-.022.2-.065.29a.73.73 0 0 1-.176.235.87.87 0 0 1-1.149 0 .701.701 0 0 1-.236-.525z"
        fill="#FFF"
        mask="url(#prefix__b)"
      />
    </g>
  </svg>
)

export default NoticeComponent;



// WEBPACK FOOTER //
// ./src/components/Form/FormHelper/iconComponent/noticeCmp.js